
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/base/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pages-pages-reference-base-demo-base"],
  getter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/base/index.md?type=demo')
};